/* ============================================================================
   General Knot & Co. — custom JavaScript
   ============================================================================

   Mega menu hover images.

   Pairs with the GK CUSTOM additions in snippets/nav-item.liquid, which stamp
   data-nav-image and data-nav-title onto each mega menu link and render a
   .gk-nav-image panel.

   Hovering a link swaps the panel image and caption. Leaving the dropdown
   restores the default. Images are preloaded on first hover of the menu item
   so the swap doesn't flash.

   NOTE: the hover panel only renders on menu items that have NO native
   Broadcast image block assigned. If a menu item shows a static image and
   won't swap, hide its Image block in Header settings.

   No dependencies. Safe to run before or after theme.js.
   ============================================================================ */

(function () {
  'use strict';

  var FADE_MS = 180;

  function initPanel(panel) {
    // Guard against double-binding when sections re-render in the editor.
    if (panel.dataset.gkNavBound === 'true') return;

    var img = panel.querySelector('[data-nav-hover-img]');
    var caption = panel.querySelector('[data-nav-hover-title]');
    if (!img) return;

    var item = panel.closest('.menu__item');
    var dropdown = panel.closest('.header__dropdown');
    if (!item || !dropdown) return;

    var links = dropdown.querySelectorAll('a[data-nav-image]');
    if (!links.length) return;

    panel.dataset.gkNavBound = 'true';

    var defaultSrc = img.getAttribute('data-default-src') || img.getAttribute('src');
    var defaultTitle = caption
      ? caption.getAttribute('data-default-title') || caption.textContent
      : '';

    var preloaded = false;
    var currentSrc = defaultSrc;
    var fadeTimer = null;

    // Preload every image in this panel once, the first time the menu opens.
    function preload() {
      if (preloaded) return;
      preloaded = true;
      Array.prototype.forEach.call(links, function (link) {
        var src = link.getAttribute('data-nav-image');
        if (!src || src === defaultSrc) return;
        var pre = new Image();
        pre.src = src;
      });
    }

    function swap(src, title) {
      if (!src || src === currentSrc) return;
      currentSrc = src;

      if (fadeTimer) clearTimeout(fadeTimer);
      panel.classList.add('is-swapping');

      fadeTimer = setTimeout(function () {
        img.setAttribute('src', src);
        if (caption && title) caption.textContent = title;
        panel.classList.remove('is-swapping');
      }, FADE_MS);
    }

    item.addEventListener('mouseenter', preload);
    item.addEventListener('focusin', preload);

    Array.prototype.forEach.call(links, function (link) {
      function activate() {
        swap(link.getAttribute('data-nav-image'), link.getAttribute('data-nav-title'));
      }
      link.addEventListener('mouseenter', activate);
      // Keyboard parity — tabbing through the menu moves the image too.
      link.addEventListener('focus', activate);
    });

    item.addEventListener('mouseleave', function () {
      swap(defaultSrc, defaultTitle);
    });
  }

  function initNavHoverImages() {
    var panels = document.querySelectorAll('[data-nav-hover-image]');
    Array.prototype.forEach.call(panels, initPanel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initNavHoverImages);
  } else {
    initNavHoverImages();
  }

  // The theme editor re-renders sections, which destroys our listeners and
  // produces fresh unbound panels. Re-scan on section load; initPanel's
  // data-gk-nav-bound guard stops already-bound panels being double-bound.
  document.addEventListener('shopify:section:load', initNavHoverImages);
})();
